var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagramIkona(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Insta",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 65.6 65.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "instagram_ikona") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.65,6.88A7.6,7.6,0,0,0,58,0H7.67A6,6,0,0,0,6.29.11,7.63,7.63,0,0,0,.05,7.72V57.88a5.15,5.15,0,0,0,.11,1.27A7.61,7.61,0,0,0,7.56,65.6H59.09a7.52,7.52,0,0,0,6.56-7.41V6.88ZM33,20.21A12.59,12.59,0,1,1,20.36,32.8,12.55,12.55,0,0,1,33,20.21Zm25.18,7.94V55.34a2.56,2.56,0,0,1-2.75,2.75H10.31a2.5,2.5,0,0,1-2.65-2.65V27.83h5.71a19.75,19.75,0,0,0,1.8,14.71A19.5,19.5,0,0,0,23,50.47,20.24,20.24,0,0,0,51.79,40a19.91,19.91,0,0,0,.63-12.17h5.71Zm0-10.47a2.47,2.47,0,0,1-2.65,2.54H48.09a2.44,2.44,0,0,1-2.54-2.54V10.05a2.51,2.51,0,0,1,2.54-2.54h7.41A2.44,2.44,0,0,1,58,10.05C58.14,12.7,58.14,15.13,58.14,17.67Z",
    transform: "translate(-0.05)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIkona);
export default __webpack_public_path__ + "static/media/instagram_ikona.298003b7d5e937507450a654b09f86e7.svg";
export { ForwardRef as ReactComponent };